// extracted by mini-css-extract-plugin
export default {"SubnavItem":"SubnavItem_SubnavItem__EiQpf"};